import PropTypes from "prop-types";
import { PureComponent } from "react";

import { injectIntl, defineMessages } from "react-intl";

import classNames from "classnames";
import { Helmet } from "react-helmet";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import spring from "react-motion/lib/spring";

import { mountCompose, unmountCompose, cycleElefriendCompose, openComposePopout } from "flavours/glitch/actions/compose";
import Column from "flavours/glitch/components/column";
import { mascot } from "flavours/glitch/initial_state";

import Motion from "../ui/util/optional_motion";

import ComposeFormContainer from "./containers/compose_form_container";
import HeaderContainer from "./containers/header_container";
import NavigationContainer from "./containers/navigation_container";
import SearchContainer from "./containers/search_container";
import SearchResultsContainer from "./containers/search_results_container";

const messages = defineMessages({
  compose: { id: "navigation_bar.compose", defaultMessage: "Compose new post" },
});

const mapStateToProps = (state, ownProps) => ({
  elefriend: state.getIn(["compose", "elefriend"]),
  showSearch: ownProps.multiColumn ? state.getIn(["search", "submitted"]) && !state.getIn(["search", "hidden"]) : false,
  popoutEnabled: state.getIn(["compose", "popout_enabled"]),
});

const mapDispatchToProps = (dispatch) => ({
  onClickElefriend () {
    dispatch(cycleElefriendCompose());
  },

  onMount () {
    dispatch(mountCompose());
  },

  onUnmount () {
    dispatch(unmountCompose());
  },

  onOpenPopout () {
    dispatch(openComposePopout());
  },
});

class Compose extends PureComponent {

  static propTypes = {
    multiColumn: PropTypes.bool,
    showSearch: PropTypes.bool,
    elefriend: PropTypes.number,
    onClickElefriend: PropTypes.func,
    onMount: PropTypes.func,
    onUnmount: PropTypes.func,
    onOpenPopout: PropTypes.func,
    popoutEnabled: PropTypes.bool,
    intl: PropTypes.object.isRequired,
    history: PropTypes.object,
  };

  componentDidMount () {
    this.props.onMount();
    this.handOverToPopout();
  }

  componentDidUpdate () {
    this.handOverToPopout();
  }

  componentWillUnmount () {
    this.props.onUnmount();
  }

  // The single-column layout writes in the pop-out composer: opened directly (a
  // link or bookmark to /publish), this page opens it and steps back.
  handOverToPopout () {
    const { multiColumn, history, popoutEnabled } = this.props;

    if (multiColumn || !history || !popoutEnabled || this.handedOver) {
      return;
    }

    this.handedOver = true;
    this.props.onOpenPopout();

    if (history.length > 1) {
      history.goBack();
    } else {
      history.replace("/home");
    }
  }

  render () {
    const {
      elefriend,
      intl,
      multiColumn,
      onClickElefriend,
      showSearch,
    } = this.props;
    const computedClass = classNames("drawer", `mbstobon-${elefriend}`);

    if (multiColumn) {
      return (
        <div className={computedClass} role='region' aria-label={intl.formatMessage(messages.compose)}>
          <HeaderContainer />

          {multiColumn && <SearchContainer />}

          <div className='drawer__pager'>
            <div className='drawer__inner'>
              <NavigationContainer />

              <ComposeFormContainer />

              <div className='drawer__inner__mastodon'>
                {mascot ? <img alt='' draggable='false' src={mascot} /> : <button className='mastodon' onClick={onClickElefriend} />}
              </div>
            </div>

            <Motion defaultStyle={{ x: -100 }} style={{ x: spring(showSearch ? 0 : -100, { stiffness: 210, damping: 20 }) }}>
              {({ x }) => (
                <div className='drawer__inner darker' style={{ transform: `translateX(${x}%)`, visibility: x === -100 ? "hidden" : "visible" }}>
                  <SearchResultsContainer />
                </div>
              )}
            </Motion>
          </div>
        </div>
      );
    }

    return (
      <Column>
        <NavigationContainer />
        <ComposeFormContainer />

        <Helmet>
          <meta name='robots' content='noindex' />
        </Helmet>
      </Column>
    );
  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Compose)));
